export default __webpack_public_path__ + "static/twm-logo-white-00776ad657f7bb777cf5a177f5aaab09.svg";